import FormSectionTitle from "../../form/FormSectionTitle";
import Icon from "../../common/Icon";
import {useEffect, useState} from "react";
import {useQuery} from "react-query";
import {
  getAccomodationApiChannels,
  getAccomodationPolicyRate,
  getAccomodationPolicyRates,
  getPolicies,
  saveAccomodation,
  saveAccomodationPolicyRate, saveAccomodationRate
} from "../../../shared/queries";
import Modal from "../../common/Modal";
import ModalCard from "../../common/ModalCard";
import Chip from "../../common/Chip";
import {Accomodation} from "../../../types";
import toast from "react-hot-toast";
import Toggle from "react-toggle";
import { getProductName } from "../../../shared/utils";

type ProductConfigurationType = {
  code: string,
  rates: string[],
  policies: string[],
  fixedCost: boolean,
  perPerson: boolean,
  perNight: boolean,
  commission: {
    insurance: number,
    internal: number,
    insuranceFixed: number,
    internalFixed: number
  }
}

const products = [
  {
    code: 'BSR1',
    rates: ['MANUAL'],
    policies: ['131121', '121121'],
    commission: {
      insurance: 2.1,
      internal: 1.9
    }
  },
  {
    code: 'BSR2',
    rates: ['WINTER'],
    policies: ['1966613', '121121', '100987699'],
    commission: {
      insurance: 2.1,
      internal: 1
    }
  },
  {
    code: 'BSR11',
    rates: ['BUSINESS'],
    policies: ['123'],
    commission: {
      insurance: 1.9,
      internal: 2.1
    }
  },
  {
    code: 'BSR10',
    rates: ['SUMMER'],
    policies: ['131121', '121121', '67530022-PV22'],
    commission: {
      insurance: 2.1,
      internal: 1.9
    }
  },
  {
    code: 'BSR13',
    rates: ['MANUAL'],
    policies: ['1966613'],
    commission: {
      insurance: 1.56,
      internal: 1.44
    }
  },
  {
    code: 'BSR12',
    rates: ['MANUAL_PLUS'],
    policies: ['1966613', '121121'],
    commission: {
      insurance: 1.96,
      internal: 2.04
    }
  },
  {
    code: 'BSR16',
    rates: ['SANITARY'],
    policies: ['121121'],
    commission: {
      insurance: 0.25,
      internal: 0.75
    }
  },
  {
    code: 'BSR17',
    rates: ['MANUAL'],
    policies: ['41753Q'],
    commission: {
      insurance: 0.25,
      internal: 0.75
    }
  },
  {
    code: 'BSR18',
    rates: ['MANUAL_PLUS_INTERRUPTION'],
    policies: ['1966613', '121121', 'B0024-INT'],
    commission: {
      insurance: 1.5,
      internal: 0.5
    }
  },
  {
    code: 'BSR19',
    rates: ['WORLD_SANITARY'],
    policies: ['ITB69-I24-27A1'],
    fixedCost: true,
    perPerson: true,
    commission: {
      insuranceFixed: 6.89,
      internalFixed: 7.61
    }
  },
  {
    code: 'BSR20',
    rates: ['WORLD_CANC_SANITARY'],
    policies: ['ITB69-I24-27A1', '1966613'],
    fixedCost: true,
    perPerson: true,
    commission: {
      insuranceFixed: 6.89,
      internalFixed: 7.61,
      insurance: 1.56,
      internal: 2.44
    }
  },
  {
    code: 'BSR21',
    rates: ['BESAFE_RAIN'],
    policies: ['OX00024356'],
    fixedCost: false,
    perPerson: false,
    commission: {
      insuranceFixed: 0,
      internalFixed: 0,
      insurance: 1.66,
      internal: 0.34
    }
  },
  {
    code: 'BSR22',
    rates: ['WORLD_FIXED_SANITARY'],
    policies: ['ITB61-UPG'],
    fixedCost: true,
    perPerson: true,
    commission: {
      insuranceFixed: 6.89,
      internalFixed: 7.61
    }
  },
  {
    code: 'BSR23',
    rates: ['WORLD_FIXED_CANC_SANITARY'],
    policies: ['ITB61-UPG', '1966613'],
    fixedCost: true,
    perPerson: true,
    commission: {
      insuranceFixed: 6.89,
      internalFixed: 7.61,
      insurance: 1.56,
      internal: 2.44
    }
  }
] as ProductConfigurationType[]

export default function HotelProductList ({ accomodation, onComplete } : { accomodation: Accomodation, onComplete: () => void }) {

  const [assignLoading, setAssignLoading] = useState(false)

  const {
    data: connectedSystems
  } = useQuery(['accomodationApiChannel', accomodation.idAccomodation], () => getAccomodationApiChannels((accomodation && accomodation.idAccomodation) ? accomodation.idAccomodation.toString() : '0'), {
    enabled: (accomodation !== undefined)
  })

  const {
    data
  } = useQuery('policies', getPolicies)

  const [toggledRates, setToggledRates] = useState<any>([])
  const [currentProduct, setCurrentProduct] = useState<string | undefined>()
  const [productConfiguration, setProductConfiguration] = useState<ProductConfigurationType | undefined>()

  useEffect(() => {
    const config = products.find(p => p.code === currentProduct)
    if (config) setProductConfiguration(config)
  }, [
    currentProduct
  ])

  function getConnectedRateList () {
    if (connectedSystems) {
      return connectedSystems.map(cs => JSON.parse(cs.apiProps)).map((props: any) => {
        return props.rates
      }).flat()
    }
    return []
  }

  async function handleProductActivation () {
    try {
      setAssignLoading(true)
      if (!accomodation || !accomodation.idAccomodation || !productConfiguration || !data) return
      // check the default rate code, if there is already an association with something
      const ratePolicyMap = await getAccomodationPolicyRates(accomodation.idAccomodation)
      // now get all the rates that must be mapped
      const rateToBeActivated = [
        ...productConfiguration.rates,
        ...toggledRates
      ]
      // is there any rate already mapped in the rate policy map?
      if (Object.keys(ratePolicyMap).find(k => rateToBeActivated.indexOf(k) > -1)) {
        // can not continue, rates are already mapped
        toast.error('Impossibile procedere, alcune delle tariffe selezionate sono già configurate. Cancella la configurazione esistente per procedere.')
        return
      }
      const ratePlans = await getAccomodationPolicyRate(accomodation.idAccomodation)
      // is there any commission plan assigned to the current rate?
      if (ratePlans.find(r => {
        if (r.connectedRates) {
          const parsedRates = r.connectedRates.split(',')
          return parsedRates.some(pr => rateToBeActivated.includes(pr))
        }
      })) {
        toast.error('Impossibile procedere, esiste già un piano commissionale associato alle tariffe da configurare. Cancella il piano per procedere.')
        return
      }
      // at this point, we are sure there is not intersection, we can proceed with the configuration
      // step one is to associate policies where not already asscoiated
      const policiesToBeAssociated = data.filter(p => productConfiguration.policies.includes(p.policyCode))
      const unassosciatedPolicies = policiesToBeAssociated.filter(p => {
        return !accomodation.policies.find(ap => ap.idPolicy === p.idPolicy)
      })

      await saveAccomodation({
        ...accomodation,
        policies: [
          ...accomodation.policies,
          ...unassosciatedPolicies
        ]
      })

      // step one is to create a commission plan assigned to the selected rates
      await saveAccomodationRate({
        agentRate: 0,
        accomodation: accomodation,
        connectedRates: rateToBeActivated.join(','),
        hotelRate: 0,
        insuranceRate: productConfiguration.commission.insurance || 0,
        internalRate: productConfiguration.commission.internal || 0,
        subAgentRate: 0,
        perNight: productConfiguration.perNight || false,
        perPerson: productConfiguration.perPerson || false,
        fixedCost: productConfiguration.fixedCost || false,
        insuranceFixedRate: productConfiguration.commission.insuranceFixed || 0,
        internalFixedRate: productConfiguration.commission.internalFixed || 0
      })

      // we may have more than 1 policy to be assigned
      const policyIds = productConfiguration.policies.map(p => {
        const foundPolicy = data.find(pl => pl.policyCode === p)
        return foundPolicy?.idPolicy
      })

      policyIds.forEach(pId => {
        rateToBeActivated.forEach(rate => {
          if (pId && accomodation.idAccomodation) {
            saveAccomodationPolicyRate({
              coveragePercentage: 100,
              idAccomodation: accomodation.idAccomodation,
              idPolicy: pId,
              isInternal: (getProductName(rate) !== 'ND') ? true : false,
              rateCode: rate
            })
          }
        })
      })

      toast.success('Configurazione completata')
      setProductConfiguration(undefined)
      setCurrentProduct(undefined)
      onComplete()
    } catch (e) {
      console.log(e)
    } finally {
      setAssignLoading(false)
    }
    // assign the policies to each configured rate, but ask to the user
  }

  const PolicyDescription = ({ code } : { code: string }) => {

    const policy = data ? data.find(p => p.policyCode === code) : null

    if (policy === null || policy === undefined) return (<div>ND</div>)

    return (
      <div className={'flex space-x-2'}>
        <div>
          {policy.policyCode} - {policy.policyCompany}
        </div>
        {
          policy.policyIsSanitary ?
            <Chip className={'text-red-600 bg-green-100'}>
              Sanitaria
            </Chip>
            :
            <Chip className={'text-blue-600 bg-blue-100'}>
              Cancellazione
            </Chip>
        }
      </div>
    )
  }

  const ProductButton = ({ title, code, subTitle, active, logos = [] } : { title: string, code: string, subTitle: string, active: boolean, logos: string[] }) => {

    return (
      <button
        onClick={() => setCurrentProduct(code)}
        className={`${active && 'border-orange-500 text-orange-600 bg-orange-100 border'} w-full text-left hover:bg-gray-100 customshadow bg-white rounded-md p-4`}>
        <div className="flex justify-between">
          <div className={`${active ? 'text-orange-700' : 'text-gray-700'} font-bold`}>
            {title}
          </div>
          <div className={'flex space-x-2 items-center'}>
            <span className={`font-normal ${active ? 'text-orange-700' : 'text-gray-700'} text-sm`}>{code}</span>
            {
              logos.map((logo, index) => (
                <img key={index} src={logo} className={'h-6 w-6 rounded-lg'} alt=""/>
              ))
            }
          </div>
        </div>
        <div className={`font-medium text-sm ${active ? 'text-orange-700' : 'text-gray-700'} mt-1`}>
          {subTitle}
        </div>
        {
          active ?
            <div className={'mt-2 flex space-x-1 items-center'}>
              <div>
                <Icon name={'check'} size={'20px'} />
              </div>
              <div>
                <button className={'text-orange-600 font-medium text-sm'}>Prodotto attivo</button>
              </div>
            </div>
            :
            <div className={'mt-2'}>
              <button className={'text-orange-600 font-medium text-sm'}>Attiva {'->'}</button>
            </div>
        }
      </button>
    )
  }

  return (
    <div>

      {
        productConfiguration &&
          <Modal visible={(productConfiguration !== undefined)}>
              <ModalCard
                  actionsLoading={assignLoading}
                  className={'w-full max-w-xl'}
                  title={`Attiva prodotto ${currentProduct}`}
                  onSave={() => {
                    if (currentProduct) handleProductActivation()
                  }}
                  onClose={() => {
                    setProductConfiguration(undefined)
                    setCurrentProduct(undefined)
                  }}>
                  <div className="text-gray-700 p-6">
                      Stai attivando un prodotto, il sistema associerà automaticamente le polizze elencate di seguito

                      <ul className={'list-disc pl-6 mt-4'}>
                        {productConfiguration.policies.map((p, i) => (
                          <li className={'text-gray-700 mb-2'} key={i}>
                            <PolicyDescription code={p} />
                          </li>
                        ))}
                      </ul>

                      <div className={'mt-4 text-gray-700'}>
                          Inoltre il sistema associerà le polizze alle tariffe interne
                          <div className="mt-1">
                              <span className={'flex space-x-2'}>
                                {productConfiguration.rates.map((r, i) => (
                                  <span className={'bg-orange-100 text-orange-700 px-2 py-1 rounded-xl font-semibold text-sm'} key={i}>{r}</span>
                                ))}
                              </span>
                          </div>
                      </div>

                      <div className={'mt-2 text-gray-700'}>
                          <div className="mb-4">
                            e alle seguenti tariffe esterne configurate nella connessione
                          </div>
                          <div className="mt-1">
                            <span className={'flex flex-col space-y-4'}>
                              {getConnectedRateList().map((r, i) => (
                                <div className='flex space-x-2'>
                                  <div>
                                    <Toggle
                                      id={'percentMode'}
                                      checked={toggledRates.includes(r)}
                                      onChange={e => {
                                        if (!toggledRates.includes(r)) {
                                          setToggledRates([
                                            ...toggledRates,
                                            r
                                          ])
                                        } else {
                                          setToggledRates(toggledRates.filter((ra: any) => ra !== r))
                                        }
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <div className={'bg-orange-100 text-orange-700 px-2 py-1 rounded-xl font-semibold text-sm'} key={i}>{r}</div>
                                  </div>
                                </div>
                              ))}
                          </span>
                          </div>
                      </div>
                  </div>
              </ModalCard>
          </Modal>
      }

      <FormSectionTitle
        borderless
        title={'Prodotti assicurativi'}
        subtitle={'scegli i prodotti da attivare'}
        onEdit={() => {
        }} />

      <div className="font-semibold mb-4 flex space-x-2 items-center">
        <img className={'h-6'} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAAZ0lEQVRoge3PMRGAMBBFQYIBCsyggkEGQvCBDmqEQcFgICk+zOxW11xyr+sA4MfKO6z7dNU8sC1H0wHjPFTtlfO5vW/6/QMEpAlIE5AmIE1AmoA0AWkC0gSkCUgTkCYgTUCaAACgwQ0gCQU8ebVRwQAAAABJRU5ErkJggg==" />
        <div>
          Mercato Italiano
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <ProductButton
          title={'BSR AXA'}
          subTitle={'Cancellazione + Sanitaria'}
          logos={[
            '/assets/guestportal/axalogo.jpg',
            '/assets/guestportal/axalogo.jpg'
          ]}
          code={'BSR1'}
          active={false}
        />

        <ProductButton
          title={'BSR Summer'}
          subTitle={'Cancellazione + Sanitaria + RC'}
          logos={[
            '/assets/guestportal/axalogo.jpg',
            '/assets/guestportal/axalogo.jpg',
            '/assets/guestportal/ergo.png'
          ]}
          code={'BSR10'}
          active={false}
        />
        
        <ProductButton
          title={'BSR Winter'}
          subTitle={'Cancellazione + Sanitaria + RC Neve'}
          logos={[
            '/assets/guestportal/axalogo.jpg',
            '/assets/guestportal/axalogo.jpg',
            '/assets/guestportal/ergo.png'
          ]}
          code={'BSR2'}
          active={false}
        />

        <ProductButton
          title={'BSR Business'}
          subTitle={'Cancellazione + Sanitaria + TPL'}
          logos={[
            '/assets/guestportal/axalogo.jpg'
          ]}
          code={'BSR11'}
          active={false}
        />

        <ProductButton
          title={'BSR BeSafe Plus'}
          subTitle={'Cancellazione + Sanitaria + TPL + extra'}
          logos={[
            '/assets/guestportal/revo.png',
            '/assets/guestportal/axalogo.jpg'
          ]}
          code={'BSR12'}
          active={false}
        />

        <ProductButton
          title={'BSR BeSafe Flex'}
          subTitle={'Solo spese mediche'}
          logos={[
            '/assets/guestportal/axalogo.jpg'
          ]}
          code={'BSR16'}
          active={false}
        />

        <ProductButton
          title={'BSR BeSafe Rate Classic'}
          subTitle={'Cancellazione + Sanitaria'}
          logos={[
            '/assets/guestportal/europlogo.png'
          ]}
          code={'BSR17'}
          active={false}
        />

        <ProductButton
          title={'BeSafe Plus - Interr.'}
          subTitle={'Cancellazione + Sanitaria + Int.'}
          logos={[
            '/assets/guestportal/revo.png',
            '/assets/guestportal/axalogo.jpg'
          ]}
          code={'BSR18'}
          active={false}
        />

        <ProductButton
          title={'BeSafe - Pioggia'}
          subTitle={'rimborso per pioggia'}
          logos={[
            '/assets/guestportal/revo.png'
          ]}
          code={'BSR21'}
          active={false}
        />
      </div>

      <div className="mt-8 font-semibold mb-4 flex space-x-2 items-center">
        <img className={'h-6'} src="data:image/png;base64,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" />
        <div>
          Mercato Globale
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <ProductButton
          title={'BSR BeSafe - Canc. only'}
          subTitle={'Cancellazione'}
          logos={[
            '/assets/guestportal/revo.png'
          ]}
          code={'BSR13'}
          active={false}
        />

        <ProductButton
          title={'BeSafe 1kk - pre-esistenti'}
          subTitle={'Sanitaria'}
          logos={[
            '/assets/guestportal/intmlogo.png'
          ]}
          code={'BSR19'}
          active={false}
        />

        <ProductButton
          title={'BeSafe Canc. + 1kk - pre-esistenti'}
          subTitle={'Sanitaria + Cancellazione'}
          logos={[
            '/assets/guestportal/intmlogo.png',
            '/assets/guestportal/revo.png'
          ]}
          code={'BSR20'}
          active={false}
        />

        <ProductButton
          title={'BeSafe 1kk - (da non usare)'}
          subTitle={'Sanitaria'}
          logos={[
            '/assets/guestportal/intmlogo.png'
          ]}
          code={'BSR22'}
          active={false}
        />

        <ProductButton
          title={'BeSafe Canc. + 1kk - (da non usare)'}
          subTitle={'Sanitaria + Cancellazione'}
          logos={[
            '/assets/guestportal/intmlogo.png',
            '/assets/guestportal/revo.png'
          ]}
          code={'BSR23'}
          active={false}
        />
      </div>
    </div>
  )

}
